import { useMutation, useQueryClient } from '@tanstack/react-query';

import { moveEvent } from './services';

export const useMoveEventMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['managemobi', 'events', 'move'],
    mutationFn: moveEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'events', 'search'],
      });
    },
  });
};
